import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SearchSuggestion from './Search-suggestion';
import {historyPush, getLinkQueryString} from '../services/history';
import {intlShape, injectIntl} from 'react-intl';
import {getCategoriesByQuery, getPopularSearchesByQuery} from '../services/utils';
import {getSearch} from '../services/market-api';
import {execBI} from '../services/bi-events-manager';
import injectMain from '../services/inject-main';
import _ from 'lodash';

const maxAppsCount = 3, maxPopularCount = 3, maxCategoryCount = 2;
const defaultPopularTranslate = ['search.popular.store', 'search.popular.bookings', 'search.popular.faq', 'search.popular.popup'];

const getSearchThrottle = _.throttle((query, lang, limit, callback) => {
  // Can't use Promises, throttle would always return first fulfilled Promise
  getSearch(query, lang, limit)
    .then((resp) => callback(null, resp))
    .catch((err) => callback(err));
}, 800);

class SearchInput extends React.Component {

  constructor(props) {
    super(props);
    this.handleOnFocus = this.handleOnFocus.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.searchFocused = false;
  }

  handleOnChange() {
    this.setState({
      popular: getPopularSearchesByQuery(this.input.value, maxPopularCount),
      categories: getCategoriesByQuery(this.props.categories, this.input.value, maxCategoryCount)
    });
    execBI('UPDATE_AUTO_COMPLETE_QUERY', {query: this.input.value, results: {query: this.input.value, applications: []}});

    if (this.input.value.length >= 2) {
      getSearchThrottle(this.input.value, this.props.lang, maxAppsCount, (err, resp) => {
        if (err) {
          this.setState({apps: []});
        } else {
          this.setState({apps: resp});
        }
      });

    } else {
      this.setState({apps: []});
    }
  }

  handleKeyDown(ev) {
    if (ev.keyCode === 40) {
      ev.preventDefault();
      const total = this.isEmptyQuery() ?
        defaultPopularTranslate.length :
        this.state.popular.length + this.state.apps.length + this.state.categories.length;

      this.setState({activeIndex: Math.min(this.state.activeIndex + 1, total - 1)});

    } else if (ev.keyCode === 38) {
      ev.preventDefault();
      this.setState({activeIndex: Math.max(this.state.activeIndex - 1, -1)});

    } else if (ev.keyCode === 13) {
      if (getSearchThrottle.cancel) {
        getSearchThrottle.cancel();
      }

      if (this.state.activeIndex !== -1) {
        ev.preventDefault();
        const active = this.container.querySelector('.search-suggestion .active');
        if (active) {
          this.input.blur();
          active.firstElementChild.click();
        }
      }
    }
  }

  handleOnFocus() {
    execBI('SEARCH_INPUT_FOCUS');
    this.searchFocused = true;

    setTimeout(() => {
      this.setState({showSuggestion: true, activeIndex: -1});

    }, this.isExpanded() ? 0 : 300);
  }

  handleOnBlur() {
    this.searchFocused = false;

    setTimeout(() => {
      this.setState({showSuggestion: false});
    }, 200);
  }

  handleOnSubmit(ev) {
    ev.preventDefault();
    this.input.blur();
    execBI('SEARCH_INPUT_SUBMIT', {search_term: this.input.value, origin: 'direct'});
    historyPush(`/search/${getLinkQueryString({q: this.input.value})}`);
  }

  isEmptyQuery() {
    return !(this.input && this.input.value.length > 0);
  }

  isExpanded() {
    return this.searchFocused || !this.isEmptyQuery() || this.props.search || this.props.isHome;
  }

  showPopover() {
    const state = this.state || {};

    return !!(this.isEmptyQuery() ||
      state.popular.length ||
      state.apps.length ||
      state.categories.length);
  }

  componentDidMount() {
    this.input.value = this.props.search;
    this.input.removeAttribute('name');

  }

  componentWillReceiveProps(nextProps) {
    this.input.value = nextProps.search;
    this.setState({activeIndex: -1});
  }

  componentWillMount() {
    this.setState({
      popular: [],
      apps: [],
      categories: [],
      activeIndex: -1
    });
  }


  render() {
    const {formatMessage} = this.props.intl;
    const state = this.state || {};

    const defaultPopular = defaultPopularTranslate.map((i) => formatMessage({id: i}));
    const results = {popular: state.popular, apps: state.apps, categories: state.categories};

    return (
      <div className="search-button nav-search" ref={c => this.container = c}>
        <form onSubmit={this.handleOnSubmit} className="nav-search-button" action={`${this.props.fullUrl}/search/`} method="get">
          <input type="hidden" name="metaSiteId" value={this.props.query.metaSiteId}/>
          <input
            name="q"
            className={classNames('field', {expanded: this.isExpanded()})}
            type="text"
            onFocus={this.handleOnFocus}
            onBlur={this.handleOnBlur}
            onChange={this.handleOnChange}
            onKeyDown={this.handleKeyDown}
            placeholder={formatMessage({id: 'editor.search.placeholder'})}
            ref={c => this.input = c}
            maxLength="100"
            />

          <SearchSuggestion
            empty={this.isEmptyQuery()}
            show={state.showSuggestion && this.showPopover()}
            defaultPopular={defaultPopular}
            results={results}
            activeIndex={state.activeIndex}
            getInputValue={() => this.input.value}
            />

          <input className="submit" type="submit" value=""/>
        </form>
      </div>
    );
  }
}


SearchInput.propTypes = {
  search: PropTypes.string,
  isHome: PropTypes.bool,
  categories: PropTypes.array.isRequired,
  intl: intlShape.isRequired,
  fullUrl: PropTypes.string,
  query: PropTypes.object,
  lang: PropTypes.string
};

export default injectMain(injectIntl(SearchInput));



// WEBPACK FOOTER //
// ./components/Search-input.js